import { CSSProperties } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { categoryToIcon } from "../../lib/definitions";
import { TEXT_COLOR } from "../../lib/style_definitions";
import { categoryToColor } from "../../lib/lib";
import { EcoLabel } from "../elements/ecoLabel";
import { MIconButton } from "../elements/miconButton";
import { ItemCategory } from "@ckal-software/ckal-lib/dist/apps/madplanen";

interface ItemOptionProps {
  name: string;
  category: ItemCategory | "New" | "";
  disabled?: boolean;
  isOrganic?: boolean;
  inlineEcoLabel?: boolean;
  small?: boolean;
  style?: CSSProperties;
  onClick(): void;
}

export function ItemOption(props: ItemOptionProps) {
  return (
    <div
      style={{
        display: "flex",
        padding: props.small ? "6px 12px" : "8px 16px",
        margin: "0 8px",
        borderRadius: 12,
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        color: props.disabled ? "#b0b0b0" : TEXT_COLOR,
        opacity: props.disabled ? 0.5 : 1,
        cursor: props.disabled ? "default" : "pointer",
        WebkitTapHighlightColor: "transparent",
        ...props.style,
      }}
      onClick={() => {
        if (props.disabled) {
          return;
        }
        props.onClick();
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {props.category === "" ? null : props.category === "New" ? (
          <MIconButton
            title="Opret vare"
            type="primary"
            icon={<PlusOutlined />}
            disabled={props.disabled}
            style={{ width: 30, height: 30, borderRadius: 8, fontSize: 18 }}
          />
        ) : (
          <div
            style={{
              fontSize: 18,
              display: "flex",
              width: 30,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 8,
              background: `color-mix(in srgb, ${categoryToColor[props.category] || "#d1d5db"} 15%, transparent)`,
            }}
          >
            {categoryToIcon[props.category]}
          </div>
        )}
        <div
          style={{
            fontSize: 14,
            fontWeight: 500,
            wordBreak: "break-word",
          }}
        >
          {props.name}
          {props.isOrganic && props.inlineEcoLabel && (
            <EcoLabel
              size={1}
              style={{ marginLeft: 6, verticalAlign: "middle" }}
            />
          )}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {props.isOrganic && !props.inlineEcoLabel && <EcoLabel size={1} />}
      </div>
    </div>
  );
}
